<template>
  <div v-if="isTimeSalesMgt" class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content" @click.self="close">
    <div class="relative w-full lg:w-[83%] max-h-screen bg-[#f8f8f8] p-[40px] overflow-auto">
      <button class="absolute right-12 top-12 cursor-pointer z-10" type="button" @click="close">
        <span class="mdi text-xl mdi-close"></span>
      </button>
      <div class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]">
        <h2 class="text-[#353535] text-[20px] leading-[28px] font-semibold">
          Viewing Sales Report By: Purchase Process Lead Time Sales Manager Report
        </h2>
        <div
          class="flex xs:flex-col xl:flex-row xs:justify-start xl:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 xl:items-center">
          <p class="text-[#353535] text-[14px] leading-[20px] font-medium">
            All SKU sales reports this year
          </p>
          <div class="flex gap-1 sm:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center">
            <button @click="viewFilter"
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none">
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filters
            </button>
            <button @click="csvExport(csvData)"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none">
              <span class="">
                <img src="/assets/icon/export.svg" alt="" />
              </span>
              Export Data
            </button>
            <button
              class="border-[1px] bg-[#7367f0] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
              @click="exportAllData" :disabled="isExportAllLoading">
              <span v-if="isExportAllLoading" class="fa-solid fa-spinner fa-spin"></span>
              <span v-else class="feather icon-download text-white"></span>
              {{ isExportAllLoading ? 'Loading...' : 'Export All' }}
            </button>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table p-0 m-0 dataTable no-footer text-nowrap">
          <thead class="bg-white">
            <tr class="py-[5px]">
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Approved By
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Avg Lead Time (Seconds)
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Avg Lead Time (Minutes)
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Avg Lead Time (Hours)
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Avg Lead Time (Days)
              </th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr v-if="loading">
              <td colspan="12" class="text-center">
                <div class="text-center" style="padding-top: 100px; padding-bottom: 50px">
                  <span class="fa-solid fa-spinner fa-spin text-[#2463EB]" style="font-size: 8rem"></span>
                  <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                    style="padding-bottom: 100px">
                    Please wait
                  </h3>
                </div>
              </td>
            </tr>
            <tr v-for="item in ReportItems" :key="item.rowNum" v-else>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ item.orderApprovedBy }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ formatNumber(item.approvedLeadTimeSeconds) }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ formatNumber(item.approvedLeadTimeMinutes) }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ formatNumber(item.approvedLeadTimeHours) }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ formatNumber(item.approvedLeadTimeDays) }}
              </td>
            </tr>
            <tr v-if="!ReportItems.length && !loading">
              <td colspan="12">
                <div class="text-center">No matching records</div>
              </td>
            </tr>
          </tbody>
        </table>
        <Pagination :limit="pageSize" :count="pageCount" :page="page" :itemsCount="count" @gotoPage="gotoPage"
          @changeLimit="changeLimit" />
      </div>
    </div>
    <div class="modal fade py-1" id="mod-filter" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4 class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]">
              Filter
            </h4>
            <button class="text-2xl text-[#353535]" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="mb-[16px]">
              <label class="text-[#353535] font-bold-500 text-[14px] leading-[20px]">Start Date</label>
              <div>
                <input type="date" :max="maxDate" placeholder="Select a date" v-model="filter.dateStart"
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none" />
              </div>
              <div class="my-[16px]">
                <label class="text-[#353535] font-bold-500 text-[14px] leading-[20px]">End Date</label>
                <input type="date" :max="maxDate"
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                  placeholder="Select a date" v-model="filter.dateEnd" />
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button" data-dismiss="modal">
              Cancel
            </button>
            <button
              class="border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button" @click="reset">
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[#2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button" @click="getPurchaseProcessLeadTimeSalesManagerReport">
              {{ loading ? "Loading..." : "Search" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import Select2 from "@/components/Select2";
import { helper } from "@/helper";
import moment from "moment";
import Pagination from "../Pagination.vue";

export default {
  name: "ManufacturerPurchaseProcessLeadTimeSalesManagerReport",
  components: {
    Select2,
    Pagination,
  },
  props: ["close"],
  created() {
    this.getPurchaseProcessLeadTimeSalesManagerReport();
  },
  data() {
    return {
      filter: {
        qry: "",
        status: "0",
        dateStart: moment()
          .subtract(1, "years")
          .format("YYYY-MM-DD"),
        dateEnd: moment().format("YYYY-MM-DD"),
      },
      isBusy: false,
      isBusyModal: false,
      loading: false,
      isExportAllLoading: false,
      ReportItems: [],
      ExportReportItemsAll: [],
      isTimeSalesMgt: true,
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      pageSizeExport: 99999999,
      hasNext: false,
      hasPrev: false,
      options: {
        format: "YYYY-MM-DD",
        icons: {
          time: "mdi mdi-time",
          date: "mdi mdi-calendar",
          up: "mdi mdi-chevron-up",
          down: "mdi mdi-chevron-down",
          previous: "mdi mdi-chevron-left",
          next: "mdi mdi-chevron-right",
          today: "mdi mdi-screenshot",
          clear: "mdi mdi-trash",
          close: "mdi mdi-remove",
        },
      },
      local: {
        dow: 0, // Sunday is the first day of the week
        hourTip: "Select Hour", // tip of select hour
        minuteTip: "Select Minute", // tip of select minute
        secondTip: "Select Second", // tip of select second
        yearSuffix: "", // suffix of head year
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ), // months of head
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), // months of panel
        weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks
        cancelTip: "cancel",
        submitTip: "confirm",
      },
      maxDate: "",
    };
  },
  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },
    csvData() {
      return this.exportItems.map((item) => ({
        ...item,
      }));
    },
    exportItems() {
      return this.ReportItems.map(function (item) {
        return {
          "Approved By": item.orderApprovedBy,
          "Lead Time (Seconds)": item.approvedLeadTimeSeconds,
          "Lead Time (Minutes)": item.approvedLeadTimeMinutes,
          "Lead Time (Hours)": item.approvedLeadTimeHours,
          "Lead Time (Days)": item.approvedLeadTimeDays,
        };
      });
    },
    csvDataAll() {
      return this.exportItemsAll.map((item) => ({
        ...item,
      }));
    },
    exportItemsAll() {
      return this.ExportReportItemsAll.map(function (item) {
        return {
          "Approved By": item.orderApprovedBy,
          "Lead Time (Seconds)": item.approvedLeadTimeSeconds,
          "Lead Time (Minutes)": item.approvedLeadTimeMinutes,
          "Lead Time (Hours)": item.approvedLeadTimeHours,
          "Lead Time (Days)": item.approvedLeadTimeDays,
        };
      });
    },
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
  },
  methods: {
    reset() {
      this.page = 1;
      this.filter = {
        qry: "",
        status: "0",
        dateStart: moment()
          .subtract(1, "years")
          .format("YYYY-MM-DD"),
        dateEnd: moment().format("YYYY-MM-DD"),
      };
    },
    viewFilter() {
      $("#mod-filter").modal("show");
    },
    async exportAllData() {
      this.isExportAllLoading = true;
      try {
        if (!this.ExportReportItemsAll.length) {
          await this.getPurchaseProcessLeadTimeSalesManagerReportAllItems();
        }
        if (this.csvDataAll.length === 0) {
          alert("No data available to export. Please check the filters or try a different date range.");
          return;
        }
        this.csvExport(this.csvDataAll);
      } catch (error) {
      } finally {
        this.isExportAllLoading = false;
      }
    },
    getPurchaseProcessLeadTimeSalesManagerReportAllItems() {
      return new Promise((resolve, reject) => {
        this.isBusy = true;
        const url =
          "/Reports/getPurchaseProcessLeadTimeSalesManagerReport?page=0" +
          "&pageSize=" +
          this.pageSizeExport +
          (this.filter.dateStart
            ? "&startDate=" +
            moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
            : "") +
          (this.filter.dateEnd
            ? "&endDate=" +
            moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
            : "") +
          (this.user.parentId ? "&parentId=" + this.user.parentId : "");
        this.$http
          .get(url)
          .then((res) => {
            const data = res.body && res.body.data ? res.body.data : [];
            this.ExportReportItemsAll = data;
            $("#mod-filter").modal("hide");
            this.isBusy = false;
            resolve(data);
          })
          .catch((err) => {
            $("#mod-filter").modal("hide");
            this.isBusy = false;
            reject(err);
          });
      });
    },
    getPurchaseProcessLeadTimeSalesManagerReport() {
      this.isBusy = true;
      this.loading = true;
      const url =
        "/Reports/getPurchaseProcessLeadTimeSalesManagerReport?page=" +
        (this.page - 1) +
        "&pageSize=" +
        this.pageSize +
        (this.filter.dateStart
          ? "&startDate=" +
          moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
          : "") +
        (this.filter.dateEnd
          ? "&endDate=" +
          moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
          : "") +
        (this.user.parentId ? "&parentId=" + this.user.parentId : "");
      this.$http
        .get(url)
        .then((res) => {
          this.ReportItems = res.body.data || [];
          this.page = res.body.page + 1;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count || 0;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize) || 0;
          this.hasPrev = res.body.hasPrev || false;
          this.hasNext = res.body.hasNext || false;

          $("#mod-filter").modal("hide");
          this.isBusy = false;
          this.loading = false;
        })
        .catch((err) => {
          $("#mod-filter").modal("hide");
          this.isBusy = false;
          this.loading = false;
        });
    },
    formatDate(date) {
      return moment(date).format("lll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    formatNumber(val) {
      return helper.formatNumber(val);
    },
    csvExport(arrData) {
      if (!arrData.length) {
        alert("No data to export.");
        return;
      }
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map((item) => Object.values(item).join(",")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute(
        "download",
        "manufacturer_process_lead_time_sales_manager.csv"
      );
      link.click();
    },
    prev() {
      if (this.page > 1) {
        this.page -= 1;
        this.getPurchaseProcessLeadTimeSalesManagerReport();
      }
    },
    next() {
      if (this.hasNext) {
        this.page += 1;
        this.getPurchaseProcessLeadTimeSalesManagerReport();
      }
    },
    gotoPage(page) {
      this.page = page;
      this.getPurchaseProcessLeadTimeSalesManagerReport();
    },
    changeLimit(limit) {
      this.pageSize = limit;
      this.page = 1;
      this.getPurchaseProcessLeadTimeSalesManagerReport();
    },
  },
};
</script>